import { render, staticRenderFns } from "./InfoLineItemsResponsive.vue?vue&type=template&id=70278b04&scoped=true"
import script from "./InfoLineItemsResponsive.vue?vue&type=script&lang=js"
export * from "./InfoLineItemsResponsive.vue?vue&type=script&lang=js"
import style0 from "./InfoLineItemsResponsive.vue?vue&type=style&index=0&id=70278b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70278b04",
  null
  
)

export default component.exports